<template>
	<v-container fluid class="ma-0 pa-0">
		<Header @currentGroup="currentGroupFunc" />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-5 mt-7" cols="12" align="center">
				<v-col class="ma-0 pa-0" cols="12"
					v-if="viewCount == 4">
					<v-row class="ma-0 pa-2" align="center">
						<v-col class="ma-0 pa-0 pr-2" cols="6" align="right">
							<v-col v-for="(item, index) in 2" :key="index" id="camera_4box" class="ma-0 pa-0 mb-4" cols="12">
								<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
									<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
										id="blue_btn" elevation="0" @click="cameraSelect(index, $event)">
										{{tsg('selectCamera')}}
									</v-btn>
								</v-col>
				  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
                  {{'cameraName'}}
				  			</v-col>
							</v-col>
						</v-col>
						<v-col class="ma-0 pa-0 pl-2" cols="6" align="left">
							<v-col v-for="(item, index) in 2" :key="index" id="camera_4box" class="ma-0 pa-0 mb-4" cols="12">
								<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
									<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
										id="blue_btn" elevation="0" @click="cameraSelect(index+2, $event)">
										{{tsg('selectCamera')}}
									</v-btn>
								</v-col>
				  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
                  {{'cameraName'}}
				  			</v-col>
							</v-col>
						</v-col>
					</v-row>
				</v-col>

				<v-col class="ma-0 pa-0" cols="12"
					v-if="viewCount == 9">
					<v-row class="ma-0 pa-0 pl-1 pr-1" align="center">
						<v-col v-for="(item, index) in 3" :key="index" class="ma-0 pa-0 pr-1 pl-1" cols="4">
							<v-col v-for="(item_nest, index_nest) in 3" :key="index_nest" id="camera_9box" 
								class="ma-0 pa-0 mb-2" cols="12">
								<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
									<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
										id="blue_btn" elevation="0" @click="cameraSelect(index_nest + 3*index, $event)">
										{{tsg('selectCamera')}}
									</v-btn>
								</v-col>
				  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
                  {{'cameraName'}}
				  			</v-col>
							</v-col>
						</v-col>
					</v-row>
				</v-col>

				<v-col class="ma-0 pa-0" cols="12"
					v-if="viewCount == 16">
					<v-row class="ma-0 pa-2" align="center">
						<v-col v-for="(item, index) in 4" :key="index" class="ma-0 pa-0 pl-1 pr-1" cols="3">
							<v-col v-for="(item_nest, index_nest) in 4" :key="index_nest" id="camera_16box" 
								class="ma-0 pa-0 mb-2" cols="12">
								<v-col id="camera_select_btn" class="ma-0 pa-0" cols="auto">
									<v-btn width="8rem" height="2rem" class="ma-0 pa-0" 
										id="blue_btn" elevation="0" @click="cameraSelect(index_nest + 4*index, $event)">
										{{tsg('selectCamera')}}
									</v-btn>
								</v-col>
				  			<v-col id="camera_select_bottom_bar" style="display:none;" class="ma-0 pa-0 ellipsis" cols="12">
                  {{'cameraName'}}
				  			</v-col>
							</v-col>
						</v-col>
					</v-row>
				</v-col>

				<v-col class="ma-0 pa-0 mt-3 mb-7" cols="12">
					<v-row class="ma-0 pa-0" align="center" justify="center">
						<v-btn width="9rem" height="2rem" class="ma-0 pa-0" 
							id="grey_btn" elevation="0" @click="pagePop">
							{{t('cancel')}}
						</v-btn>
						<v-btn width="9rem" height="2rem" class="ma-0 pa-0 ml-3" 
							id="blue_btn" elevation="0" @click="goSplitScreen"
							:loading="createLoading">
							{{t('create')}}
						</v-btn>
					</v-row>
				</v-col>
			</v-col>
		</v-col>
    <CameraSearchDialog :dialogVisible="cameraSearchDialogVisible" :storeListData="storeList" 
			:checkBoxVisible="checkable" :storeInGroupData="currentGroup"
      @visible="cameraSearchDialogVisibleFunc" @selectedCamera="modifySelectedCameraFunc" />
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from '../Header.vue';
import CameraSearchDialog from '@/components/dialogs/CameraSearchDialog.vue';
import $ from 'jquery';
export default {
	components: {
		Header, CameraSearchDialog
	},
	mixins: [mixin.common],
	data: () => ({
		viewCount: 4,
		currentGroupId: '',
    cameraSearchDialogVisible: false,
    storeList: [],
    brandList: [],
    checkable: false,
    selectedCamera: null,
    selectedIndex: null,
    selectedCameraList: [],
		createLoading: false,
    listCount: 1, //번호 붙이기를 위한 리스트 갯수
    currentGroup: [],
	}),
	created() {
		this.viewCount = Number(this.$route.query.view);
		this.currentGroupId = this.$route.query.groupId;
    this.getSplitList();
	},
  mounted() {
		this.getBrandData();
    console.log(this.storeGroupList);
  },
	methods: {
		tsg(t) {
      return this.$t("lang.group." + t);
    },
		pagePop() {
			this.replaceRoute('/split-screen/view-select', {groupId: this.currentGroupId});
		},
		async goSplitScreen() {
			this.createLoading = true;
      let params = {
        storeGroupId: this.currentGroupId,
        splitName: "名称未設定" + this.listCount,
        cameras: this.selectedCameraList,
				viewCount: this.viewCount
      };
      await this.networkController.addCameraSplit(params)
      .then(async (res) => {
				this.createLoading = false;
        this.$store.commit('setSelectedSplitScreen', params.splitName);
			  this.pushRoute('/split-screen/viewer', {
			  	view: this.viewCount, 
			  	groupId: this.currentGroupId,
			  });
      }).catch(error => {
        this.createLoading = false;
      });
		},
    async getSplitList() { //생성 시 번호를 붙이기 위해 전체 리스트 길이 구하기
      let params = {};
      await this.networkController.getCameraSplitList(params, this.currentGroupId)
      .then(async (res) => {
        let maxIndex = 0;
        res.data.forEach((item) => {
          if(item.splitName.includes('名称未設定')) {
            let tempIndex = item.splitName.split('名称未設定')[1] * 1;
            if(tempIndex >= maxIndex) {
              maxIndex = tempIndex;
            }
          }
        });
        this.listCount = maxIndex + 1;
      }).catch(error => { });
    },
    cameraSearchDialogVisibleFunc(visible) {
      this.cameraSearchDialogVisible = visible;
    },
    modifySelectedCameraFunc(item) {
      if(this.cameraSearchDialogVisible == false && item != null) {
        if(item.thumbnail.includes('null'))
          this.selectedCamera.css({"background-image" : 'none'});
        else
          this.selectedCamera.css({"background-image": 'url(' + item.thumbnail + ')', "background-size": '100% 100%'});
      this.selectedCamera.children().eq(0).css({'display': 'none'});
      this.selectedCamera.children().eq(1).html(item.cameraName);
      this.selectedCamera.children().eq(1).css({'display': 'block'});
      this.selectedCameraList.push({
        'index': this.selectedIndex,
        'contractCd': item.contractCd,
        'portNo': item.portNo,
				'thingType': item.thingType
        // 'item': item
      });
      this.selectedCameraList = this.selectedCameraList.sort((a,b) => a.index - b.index);
      }
    },
    cameraSelect(index, event) {
      this.cameraSearchDialogVisible = true
      this.selectedIndex = index;
      this.selectedCamera = $(event.currentTarget).parent().parent();
    },
		async getBrandData() {
			let params = {};
			await this.networkController.getBrandList(params).then(async (res) => {
				console.log('%cBrand Data\n', "color:#008DD0;", res.data);
        this.brandList = res.data;
			}).catch(error => { });
			await this.getAreaStores();
		},
		makeBrandCd() {
			if(this.brandList.length == 0) return '';
			let brandCd = '';
			this.brandList.forEach((item, index) => {
				if(index == 0) brandCd = item.brandCd;
				else brandCd = brandCd + ',' + item.brandCd;
			});
			return brandCd;
		},
		async getAreaStores() {
			let brandCd = await this.makeBrandCd();
			let params = {};
			await this.networkController.getStoresModalSearch(params, brandCd,'','','','')
			.then(async (res) => {
				console.log('%cArea Data\n', "color:#008DD0;", res.data);
				// Area Data 중복제거
				const arraySet = await res.data.filter((area, idx, arr) => {
					return arr.findIndex((item) => item.unisCustomerCd === area.unisCustomerCd) === idx
				});
        this.storeList = [];
        arraySet.forEach((item) => {
          let cameraListparams = {};
			    this.networkController.getStoreCameraList(cameraListparams, item.unisCustomerCd, '', '', '', '', '')
			    .then(async (res) => {
            let childrenList = [];
				    let children = [];
            let duplicateCheck = this.storeList.some((element) => {
					  	return element.id === item.areaCd
					  });

            if(res.data.length != 0) {
              res.data.forEach((item) => {
                childrenList.push({"id": item.id, "name": item.cameraName, "lastNode": true, ...item});
              });
              children.push({"id": item.unisCustomerCd, "name": item.customerName, "children": childrenList, ...item});

					    if(duplicateCheck == false) { // duplicateCheck가 true일때는 areaCd 중복
					    	this.storeList.push({"id": item.areaCd, "name": item.areaName, "children": children});
					    }
            }
			    }).catch(error => { });
        });
			}).catch(error => {
			});
      console.log('%cStore List\n', "color:#008dd0", this.storeList);
    },
    currentGroupFunc(item) {
      this.currentGroup = item;
    }
	}
}
</script>

<style lang="scss" scoped>
#camera_4box {
	background-color: #4E4E4E;
	border: 1px solid #FFFFFF;
	width: 90%;
	height: 15rem;
	min-width: 30rem;
	min-height: 15rem;
	position: relative;
}
#camera_9box {
	background-color: #4E4E4E;
	border: 1px solid #FFFFFF;
	width: 100%;
	height: 12rem;
	min-height: 12rem;
	position: relative;
}
#camera_16box {
	background-color: #4E4E4E;
	border: 1px solid #FFFFFF;
	width: 100%;
	height: 10rem;
	min-height: 10rem;
	position: relative;
}
#camera_select_btn {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 3;
}
#camera_select_bottom_bar {
  position: absolute;
  bottom: 0%;
  text-align: left;
  padding-left: 1em !important;
  font-size: 0.8em;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.7);
  color: #A8A8A8;
}
</style>